import React from 'react';
import { Typography, Grid } from '@mui/material';
import UserAccunt from '../UserAccunt';

function AppHeader() {
    return (
        <div style={{
            background: "#17365d",
            width: "100%",
            position: "fixed",
            height:80
        }}>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Grid item style={{ paddingLeft: 20 }}>
                    <Typography variant="h6" style={{ color: "#fff", paddingTop: 20 }}>
                        SPIDER ADMIN
                    </Typography>
                </Grid>
                <Grid item style={{ paddingTop: 20, marginRight: 2 }}>
                    <UserAccunt />
                </Grid>
            </Grid>

        </div>
    )
}

export default AppHeader;
